const signOut = (setIsAuthenticated) => {
	localStorage.removeItem('auth-tokens');
	localStorage.removeItem('username');
	setIsAuthenticated(false);
	// onMobileNavIconClick();
};

export default signOut;
